import Image from "next/image";
import { useRouter, useSearchParams } from "next/navigation";

import { useEffect, useState } from "react";
import AddIcon from "../AddIcon";
import ContactForm from "./ContactForm";
import styles from "./LeadGen.module.css";
export default function LeadGen() {
  const searchParams = useSearchParams();
  const paramName = "contact";
  const router = useRouter();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(searchParams.has(paramName));
  }, [searchParams]);

  const handleClose = () => {
    const params = new URLSearchParams(window.location.search);
    params.delete(paramName);
    router.replace(
      `${window.location.pathname}${params.toString() ? `?${params}` : ""}`,
      { scroll: false },
    );
    setIsOpen(false);
  };

  return (
    <aside
      className={`${styles.leadGen} ${isOpen && styles.open}`}
      data-theme="secondary"
    >
      <div className={styles.closeButton} onClick={handleClose}>
        <AddIcon />
      </div>
      <div className="grid-container remove-padding equal-height">
        <div className="sm-col-span-hide lg-col-span-5">
          <Image
            src="/leadgen.png"
            alt="Lead Generation"
            width={707 * 2}
            height={1080 * 2}
            className="w-full h-auto object-cover"
          />
        </div>
        <div className="sm-col-span-hide lg-col-span-1" />
        <div
          className={`${styles.content} sm-col-span-8 lg-col-span-5 grid-container`}
        >
          <header className={`${styles.header} sm-col-span-8 lg-col-span-6`}>
            <h2>Almost Done</h2>
          </header>
          <div className="sm-col-span-hide lg-col-span-1" />
          <ContactForm />
        </div>
      </div>
    </aside>
  );
}
